import React, { useState, useEffect, useCallback } from "react";
import { Form, Input, message } from "antd";
import API from "../api";
import urls from "../api/urls";
import { checkNumbervalue } from "../utils";

const { ADDRESS_PINCODE } = urls;

const PinCodeValidator = ({
  formName,
  value,
  disabled,
  label = "PIN code",
  clearData,
  changeHit = () => {},
  type,
  required = true,
}) => {
  const [pinCodeDetails, setPinCodeDetails] = useState({});
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  useEffect(() => {
    if (clearData) setPinCodeDetails({});
  }, [clearData]);

  const fetchPinCodeDetails = useCallback(async (pincode) => {
    try {
      const res = await API.Api(`${ADDRESS_PINCODE}${pincode}`).get();
      const data = res?.response?.data || {};

      if (!res?.status) {
        throw new Error(data?.message || "Internal server error");
      }

      const serviceability = data?.serviceability?.serviceability || "Unknown";

      if (type === "checkService") {
        setPinCodeDetails({
          status: serviceability !== "Non-Serviceable" ? "success" : "error",
          details:
            serviceability !== "Non-Serviceable"
              ? `${data.city || "Unknown"} | ${data.stateCode || "Unknown"}`
              : serviceability,
        });
      } else {
        setPinCodeDetails({
          status: "success",
          details: `${data.city || "Unknown"} | ${data.stateCode || "Unknown"}`,
        });
      }
    } catch (err) {
      message.error(err.message);
      setPinCodeDetails({ status: "error", details: err.message });
    }
  }, []);

  const handlePinCodeChange = (e) => {
    const pincode = e?.target?.value || value;
    changeHit();

    if (!pincode || pincode.length < 6) {
      setPinCodeDetails({});
      return;
    }

    clearTimeout(debounceTimeout);

    setDebounceTimeout(
      setTimeout(() => {
        fetchPinCodeDetails(pincode);
      }, 300)
    );
  };

  useEffect(() => {
    if (value) handlePinCodeChange({ target: { value } });
  }, [value]);

  return (
    <Form.Item
      label={label}
      name={formName}
      validateStatus={pinCodeDetails?.status}
      rules={[
        { required: required, message: "Please enter a pincode" },
        {
          validator(_, val = "") {
            if (val.length > 0 && val.length < 6) {
              return Promise.reject(new Error("Pincode should be 6 digits"));
            }
            if (type === "checkService") {
              if (pinCodeDetails?.status === "error") {
                return Promise.reject(new Error(pinCodeDetails?.details));
              }
            }
            return Promise.resolve();
          },
        },
      ]}
    >
      <Input
        maxLength={6}
        placeholder="Enter PIN code"
        disabled={disabled}
        onKeyPress={(e) => checkNumbervalue(e) && e.preventDefault()}
        onChange={handlePinCodeChange}
        suffix={
          <span
            className={pinCodeDetails?.status === "success" ? "green" : "red"}
          >
            {pinCodeDetails?.details}
          </span>
        }
      />
    </Form.Item>
  );
};

export default PinCodeValidator;
